<template>
  <div class="form-element-group form-element-group--inline"
       :class="{'has-error': validationErrors}">

    <label v-if="label">{{label}}</label>

    <div class="form-element"
         v-for="(option, index) in options"
         :key="index">

      <div class="form-control-flatradio">
        <label>
          <input :name="name+index"
                 v-model="currentValue"
                 @change="onInput"
                 :disabled="option.disabled"
                 :value="index"
                 type="radio">
          <span class="form__chooser__text">{{option.label}}</span>
        </label>
      </div>
    </div>
    <div class="form-explanations">
      <span v-for="(error, index) in validationErrors"
            class="form-errorText"
            :key="index">
        {{ error.message }}
      </span>
    </div>

  </div>
</template>
<script>
import validatedInputField from '@/mixins/validatedInputField'

export default {
  name: 'CsoRadioGroup',
  mixins: [validatedInputField],
  props: {
    options: {
      type: Array,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.form-errorText {
  @include error-message();
}
</style>
